export default "__VITE_ASSET__36cf4063__"